// extracted by mini-css-extract-plugin
module.exports = {"modal-header":"MapTypeInfo--modal-header--2iky5","modalHeader":"MapTypeInfo--modal-header--2iky5"};